import { FC } from 'react'

import { HistoryTable } from 'bank-entity-history/src/components/HistoryTable'
import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components'
import { PageSectionPrimary } from 'ui/components/Page'

import { CompanyHistoryProps } from './CompanyHistoryProps'
import { useCompanyHistory } from './hooks/useCompanyHistory'

export const CompanyHistoryTable: FC<CompanyHistoryProps> = (props) => {
  const {
    data: { id, history, historyTotalCount }
  } = props
  const { loading, webPageData, tableState, changePagination } = useCompanyHistory(id, history, historyTotalCount)

  return (
    <PageSectionPrimary title="Company History" anchor="history" face="outlined">
      <Layer rounded shadowed stretch>
        <HistoryTable
          dataQa={TableDataQa.BP_COMPANY_HISTORY}
          loading={loading}
          items={webPageData.history}
          pagination={{
            page: tableState.page,
            size: tableState.size,
            onChange: changePagination,
            total: webPageData.historyTotalCount
          }}
        />
      </Layer>
    </PageSectionPrimary>
  )
}
